const MIN_KEYBOARD_HEIGHT = 300;
export { MIN_KEYBOARD_HEIGHT };
